import { render, staticRenderFns } from "./descriptionsTooltip.vue?vue&type=template&id=a6a23978&scoped=true&"
import script from "./descriptionsTooltip.vue?vue&type=script&lang=js&"
export * from "./descriptionsTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a23978",
  null
  
)

export default component.exports